export function isPromotionOffer(offer) {
    return "accessoriesAlternativePrice" in offer;
}
export function isInternetOffer(offer) {
    return "internetDetail" in offer;
}
// TODO: refactor Offer types
